import Counter from './Counter.component';

export default Counter;
